<template>
  <base-display-widget :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners">
    <img class="w-full" src="../../../assets/tempmenu/img_main@2x.png" style="object-fit: unset" v-if="id<1"/>
    <div style="min-height: 100px" v-if="id>0">
      <page-prew-widget ref="pagePrewWidget" :phoneHeight="phoneHeight" :id="id"></page-prew-widget>
    </div>
  </base-display-widget>
</template>

<script>
import BaseDisplayWidget from '../base/BaseDisplayWidget'
import {parseUrl} from '@/utils/UrlFormat'
import PagePrewWidget from '../../../views/renovation/PagePrewWidget'

export default {
  name: 'LandingPageDisplayWidget',
  components: {PagePrewWidget, BaseDisplayWidget},
  props: {
    iteminfo: Object,
    phoneHeight:{
      type:Number,
      default:0
    }
  },
  watch: {
    'iteminfo.config.jumpObj.linkUrl': {
      handler (newValue) {
        if (newValue) {
          let url = this.iteminfo.config.jumpObj.linkUrl
          let par = parseUrl(url)
          if (par.contentType && parseInt(par.contentType) === 1) {
            let strId = par.id ? par.id.replace(',', '') : ''
            this.id = parseInt(strId) || 0
          } else {
            this.id = 0
          }
        } else {
          this.id = 0
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      id: 0
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
